import React, { useContext } from "react";
import { MembershipSubscriptionProvider } from "../../../types/graphql-global-types";
import { PaymentContext } from "../contexts/PaymentProvider";
import { MastercardIcon } from "../icons/MastercardIcon";
import { PayPalIcon } from "../icons/PayPalIcon";

export function PaymentMethodSelect({
  debitCreditText = "Debit/credit",
  paypalText = "PayPal",
  scrollToRef,
}: {
  debitCreditText?: string;
  paypalText?: string;
  scrollToRef?: React.RefObject<HTMLDivElement>;
}) {
  const { selectedMethod, setSelectedMethod, isReady, subscription } = useContext(PaymentContext);

  return (
    <div className="flex text-sm">
      <div
        className={`cursor-pointer bg-white rounded-l-xl p-8 w-1/2 ${
          selectedMethod === "STRIPE" ? "border-blue-500 border-2 border-r-2" : "border-grey border border-r"
        } ${
          !isReady || (subscription && subscription?.provider !== MembershipSubscriptionProvider.STRIPE)
            ? "opacity-75 cursor-not-allowed"
            : "hover:border-blue-500"
        }`}
        onClick={() => {
          if (isReady && (!subscription || subscription?.provider === MembershipSubscriptionProvider.STRIPE)) {
            setSelectedMethod("STRIPE");
            if (scrollToRef) {
              scrollToRef.current?.scrollIntoView({
                behavior: "smooth",
                block: "start",
                inline: "nearest",
              });
            }
          }
        }}
      >
        <div className="flex flex-row items-center justify-center">
          <MastercardIcon className="h-5 shrink-0 mr-1.5" /> <span>{debitCreditText}</span>
        </div>
      </div>

      <div
        className={`cursor-pointer bg-white rounded-r-xl p-8 w-1/2 ${
          selectedMethod === "PAYPAL" ? "border-blue-500 border-2 border-l-2" : "border-grey border border-l"
        } ${
          !isReady || (subscription && subscription?.provider !== MembershipSubscriptionProvider.PAYPAL)
            ? "opacity-75 cursor-not-allowed"
            : "hover:border-blue-500"
        }`}
        onClick={() => {
          if (isReady && (!subscription || subscription?.provider === MembershipSubscriptionProvider.PAYPAL)) {
            setSelectedMethod("PAYPAL");
            if (scrollToRef) {
              scrollToRef.current?.scrollIntoView({
                behavior: "smooth",
                block: "start",
                inline: "nearest",
              });
            }
          }
        }}
      >
        <div className="flex flex-row items-center justify-center">
          <PayPalIcon className="h-5 shrink-0 mr-1.5" /> <span>{paypalText}</span>
        </div>
      </div>
    </div>
  );
}
